import { render, staticRenderFns } from "./zxez_login.vue?vue&type=template&id=054c39c9&scoped=true&"
import script from "./zxez_login.vue?vue&type=script&lang=js&"
export * from "./zxez_login.vue?vue&type=script&lang=js&"
import style0 from "./zxez_login.vue?vue&type=style&index=0&id=054c39c9&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c39c9",
  null
  
)

export default component.exports